export const MARKETING_EXAM_PREVIEW = {
  src: "/exam-preview-vr.jpg",
  alt: "Med900 Verbal Reasoning exam interface showing a True, False, Can't Tell question",
};

export const MARKETING_EXAM_PREVIEW_DM = {
  src: "/exam-preview-dm.jpg",
  alt: "Med900 Decision Making exam interface showing a strongest argument multiple choice question",
};
